import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBug, IBugReportingEntityDto, ICreateBugReportRequest, IDownloadBugReportRequest } from '../../../feature/admin/content/bug-reporting/bug-report.model';
import { Observable } from 'rxjs';
import { IAppResponse } from '../../_models/network-response';
import { ApiService } from '../api/api.service';
import { IBugResult, IUpdateBugReportRequest } from './bug-reporting.model';

@Injectable({
  providedIn: 'root'
})
export class BugReportingService {

  private endpoint = "bug-reporting";

  constructor(private apiService: ApiService) { }

  getAllBugs(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.get<IBugResult<IBugReportingEntityDto>>({
      Url: `${this.endpoint}/all`,
      Params: params
    });
  }

  getById(id: string) {
    return this.apiService.get<IBugReportingEntityDto>({
      Url: `${this.endpoint}/${id}`
    });
  }

  create(report: FormData | null) {
    return this.apiService.post<object, IBugReportingEntityDto>({
      Url: `${this.endpoint}/create`,
      Body: report ?? {}
    });
  }

  update(id: string, report: IUpdateBugReportRequest) {
    return this.apiService.put<IUpdateBugReportRequest, void>({
      Url: `${this.endpoint}/${id}`,
      Body: report
    });
  }

  delete(id: string): Observable<IAppResponse<void>> {
    return this.apiService.delete<object, void>({
      Url: `${this.endpoint}/${id}`,
      Body: {}
    });
  }

  download(body: IDownloadBugReportRequest) {
     const params = new HttpParams()
      .set('fileName', body.FileName.toString())
      .set('fileSize', body.FileSize.toString())
      .set('contentType', body.ContentType.toString());
    return this.apiService.get<object>({
      Url: `${this.endpoint}/download`,
      Params: params
    });
  }

  clearCached() {
    return this.apiService.get<object>({
      Url: `${this.endpoint}/clear-cache`,
    });
  }
}
